import React, { useState } from 'react'
import icons from '../../../../../Data/icons';
import AttachModal from '../AttachModal';


const TaskListCard = ({lists ,handlePostRequest  ,openModal ,openNoteModal ,classes ,openAttachModal} ) => {
 

  const Eye = icons.eye;
  const Check = icons.checkMark;
  const TimeLineIcon = icons.timeline;
  const AttachIcon = icons.attach
  const CloseIcon =icons.close
  const user = JSON.parse(localStorage.getItem("user")) || {}
  const role = user.role   
  return (
    <div className="col-6">
    <div className={classes.tableCard}>
      {lists.map((list) => {
        console.log(list.status)
       return <div className={classes.taskContainer} key={list.id}>
          <h4
            className={`${classes.taskLabel} ${list.status ==="started" ? classes.blue :""} ${
              
              list.status === "onreview" ?  classes.yellow: ""
            }  ${list.status === "expired" ? classes.red : ""} ${
              list.status === "completed" ? classes.green : ""
            }`}>
            {list.name}
            <p>{list.description}</p>
          </h4>
          <span className={classes.taskAction}>
          <span className={classes.taskActionBtn} onClick={()=>openAttachModal(list.id)}>
              <AttachIcon />
            </span>
            <span className={classes.taskActionBtn} onClick={()=>openModal(list.id)}>
              <TimeLineIcon />
            </span>
            <span className={classes.taskActionBtn} onClick={()=>openNoteModal(list.id)}>
              <Eye />
            </span>
          {list.status !== "completed"  &&  <span
              className={classes.taskActionBtn}
              onClick={() => handlePostRequest(list.id ,"completed")}>
              <Check />
            </span>}
            {(list.status === "completed"  && role === "system_adminstrator"|| role ==="administrator") && <span
              className={classes.taskActionBtn}
              onClick={() => handlePostRequest(list.id ,"pending")}>
              <CloseIcon />
            </span>}
          </span>
        </div>
})}

    </div>
  </div>
  )
}

export default TaskListCard